import React from 'react';
import PropTypes from 'prop-types';
import { wrapFunctionalComponent } from 'utils/framework';
import RecapItem from 'components/Content/Recap/RecapItem';
import {
    Grid, Text, Button, Link
} from 'components/ui';
import RecapImage from 'components/Content/Recap/RecapImage';
import languageLocale from 'utils/LanguageLocale';
import resourceWrapper from 'utils/framework/resourceWrapper';

const getText = resourceWrapper(languageLocale.getLocaleResourceFile('components/Content/Recap/RecapBasket/locales', 'RecapBasket'));

const IMAGE_SIZE = [59, 48];

function RecapBasket({ uniqueSkus, totalItemCount, shouldRenderCarouselBasket, ...props }) {
    return (
        <RecapItem {...props}>
            {shouldRenderCarouselBasket && (
                <>
                    <Grid
                        width={IMAGE_SIZE}
                        repeat='fill'
                        gap={[1, 2]}
                    >
                        {uniqueSkus.slice(0, 3).map((sku, index) => (
                            <RecapImage
                                key={`recap_basket_${sku.skuId}`}
                                sku={sku}
                                size={IMAGE_SIZE}
                                {...(index > 1 && {
                                    display: ['none', 'block']
                                })}
                            />
                        ))}
                    </Grid>
                    <Text
                        is='p'
                        marginTop={2}
                        marginBottom='auto'
                        paddingBottom={2}
                    >
                        {getText(
                            'total',
                            false,
                            <strong children={`${totalItemCount} ${getText('item')}${totalItemCount !== 1 ? 's' : ''}`} />,
                            <Link
                                is='span'
                                color='blue'
                                underline={true}
                                children={getText('basket')}
                            />
                        )}
                    </Text>
                    <Button
                        is='span'
                        variant='special'
                        size='sm'
                        children={getText('checkout')}
                    />
                </>
            )}
        </RecapItem>
    );
}

RecapBasket.propTypes = {
    uniqueSkus: PropTypes.array.isRequired,
    totalItemCount: PropTypes.number.isRequired,
    shouldRenderCarouselBasket: PropTypes.bool.isRequired
};

export default wrapFunctionalComponent(RecapBasket, 'RecapBasket');
